// @ts-nocheck
window.customElements.define(
    "profile-menu",
    class Dropdown extends HTMLElement {
        private readonly buttonElement: Element | null;
        private readonly menuElement: Element | null;

        constructor() {
            super();

            this.buttonElement = this.querySelector("[data-profile-menu-button]");
            this.menuElement = this.querySelector("[data-profile-menu-menu]");

            this.addEventListener("click", this.onClick);
            this.addEventListener("keydown", this.onKeyDown);
            this.addEventListener("focusout", this.onFocusOut);
        }

        closeMenu() {
            this.buttonElement.setAttribute('aria-expanded', 'false');
            this.menuElement.setAttribute('aria-hidden', 'true');
        }

        isMenuOpen() {
            return (this.menuElement.getAttribute('aria-hidden') === 'false');
        }

        openMenu() {
            this.buttonElement.setAttribute('aria-expanded', 'true');
            this.menuElement.setAttribute('aria-hidden', 'false');
        }


        private onClick(event) {
            if (this.buttonElement.contains(event.target) === false) {
                return;
            }

            event.preventDefault();

            if (this.isMenuOpen()) {
                this.closeMenu();
            } else {
                this.openMenu();
            }
        }

        // eslint-disable-next-line no-underscore-dangle
        private onFocusOut(event) {
            if (this.contains(event.relatedTarget)) {
                return;
            }

            this.closeMenu();
        }

        // eslint-disable-next-line no-underscore-dangle
        private onKeyDown(event) {
            // Based on <https://twitter.com/heydonworks/status/880773131287359488>.
            const focusableElementSelector = '[href], input[type="submit"], button';

            if (event.key === 'ArrowDown') {
                event.preventDefault();

                if (this.buttonElement.contains(event.target)) {
                    if (this.isMenuOpen()) {
                        this.menuElement.querySelector(focusableElementSelector).focus();
                    } else {
                        this.openMenu();
                    }
                } else if (this.menuElement.contains(event.target)) {
                    if (this.menuElement.lastElementChild.contains(event.target)) {
                        const element = this
                            .menuElement
                            .firstElementChild
                            .querySelector(focusableElementSelector);

                        if (element) {
                            element.focus();
                        }
                    } else {
                        const element = event
                            .target
                            .closest('li')
                            .nextElementSibling
                            .querySelector(focusableElementSelector);

                        if (element) {
                            element.focus();
                        }
                    }
                }
            } else if (
                event.key === 'ArrowUp'
                && this.menuElement.contains(event.target)
            ) {
                event.preventDefault();

                if (this.menuElement.firstElementChild.contains(event.target)) {
                    const element = this
                        .menuElement
                        .lastElementChild
                        .querySelector(focusableElementSelector);

                    if (element) {
                        element.focus();
                    }
                } else {
                    const element = event
                        .target
                        .closest('li')
                        .previousElementSibling
                        .querySelector(focusableElementSelector);

                    if (element) {
                        element.focus();
                    }
                }
            } else if (event.key === 'Escape') {
                event.preventDefault();
                this.closeMenu();
                this.buttonElement.focus();
            }
        }
    },
);
